// src/components/brandCustomization/shared/ColorPicker.jsx
import React from 'react';

/**
 * ColorPicker - Selector de color reutilizable
 * Combina input type="color" con input de texto para hex code
 */
const ColorPicker = ({
    label,
    value,
    onChange,
    placeholder = '#000000',
    className = ''
}) => {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {label}
                </label>
            )}
            <div className="flex items-center gap-2">
                <input
                    type="color"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="w-12 h-10 border border-gray-300 rounded cursor-pointer"
                />
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};

export default ColorPicker;

